import { AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment-timezone';
import { MomentInput } from 'moment-timezone';
import { Subscription } from 'rxjs';

export function addDateRangeValidation<T extends MomentInput>(
  initialControl: AbstractControl<T>,
  endControl: AbstractControl<T>,
): Subscription {
  endControl.addValidators((control) =>
    validateDateRange(
      initialControl.value,
      control.value,
      'endDateMustBeGreaterThanOrEqualToStartDate',
    ),
  );
  // Use a blank message for the initial control, so that we don't
  // show a duplicate error message when the range is invalid.
  initialControl.addValidators((control) =>
    validateDateRange(control.value, endControl.value, 'blank'),
  );
  const sub = new Subscription();
  sub.add(
    initialControl.valueChanges.subscribe(() => {
      // Mark the other field as touched so that it is visually
      // marked as invalid even if it has not been directly touched.
      endControl.markAsTouched({ onlySelf: true });
      endControl.updateValueAndValidity({
        onlySelf: true,
        emitEvent: false,
      });
      // Trigger the statusChanges observable so that the internal date-time-input
      // can update its error state
      // can't use emitEvent: true above becuase that would trigger valueChanges as
      // well, resulting in infinite mutual recursion
      endControl.setErrors(endControl.errors);
    }),
  );
  sub.add(
    endControl.valueChanges.subscribe(() => {
      initialControl.markAsTouched({ onlySelf: true });
      initialControl.updateValueAndValidity({
        onlySelf: true,
        emitEvent: false,
      });
      initialControl.setErrors(initialControl.errors);
    }),
  );
  return sub;
}

function validateDateRange<T extends MomentInput>(
  initialDateInput: T,
  endDateInput: T,
  message: string,
): ValidationErrors | null {
  if (initialDateInput == null || endDateInput == null) {
    return null;
  }

  const initialDate = moment(initialDateInput);
  const endDate = moment(endDateInput);

  if (
    !(initialDate.isValid() && endDate.isValid()) ||
    endDate.isSameOrAfter(initialDate)
  ) {
    return null;
  }

  return { message };
}
